import { useNavigate, useOutletContext } from 'react-router-dom';
import { PageAbsolutePath } from '../../../consts/Common';
import { ButtonBack } from '../../common/Button/ButtonBack';
import { setCountryCode } from '../../common/HelperMethods';
import { useContext } from 'react';
import { SiteContext } from '../../../context/SiteContext';
import { InsuranceJourneyContext } from '../../common/CommonTypes';

const Referral = (): JSX.Element => {
  const navigate = useNavigate();
  const { site } = useContext(SiteContext);
  const { brand } = site;
  const { journey } = useOutletContext<InsuranceJourneyContext>();
  const brandPhoneNumber = brand.brandPhoneNumbers.quotesAndRenewalsNumber;

  const onBackClick = (): void => {
    const path: string = setCountryCode(
      PageAbsolutePath.Insurance.ConfirmationPage,
      site.countryCode
    );
    navigate(path);
  };

  return (
    <div className='referral'>
      <h3>We have been unable to process your insurance application online</h3>
      <p className='bold'>{`Your quote reference number is ${journey.quoteId}`}</p>
      <h6 className='m1-top m1-bottom '>
        Please call us on{' '}
        <a className='calltext' href={`tel:${brandPhoneNumber}`}>
          {brandPhoneNumber}
        </a>{' '}
        for assistance
      </h6>
      <hr />
      <h6 className='m1-bottom'>Monday – Thursday: 08.30 am – 7.30 pm</h6>
      <h6 className='m1-bottom'>Friday: 09.00 am – 6.00 pm</h6>
      <h6 className='m1-bottom'>Saturday: 09.00 am – 5.00 pm</h6>
      <h6 className='m1-bottom'>Sunday: Closed</h6>
      <ButtonBack
        name='btn-back'
        text='Back'
        onClick={onBackClick}
        additionalClassNames='btn-back m1-bottom'
      />
    </div>
  );
};
export default Referral;
